export default __webpack_public_path__ + "static/gap_insurance_paragraph-51038ef27744eb305d3c52212573de48.webp";